module.exports = __webpack_public_path__ + "411a6bdcf937822ee104f040b36d7fbe.png";